import { PantallaPendiente } from "@components/ui_v2";

export const BienvenidaFirmaPendiente = () => (
  <PantallaPendiente
    eyebrow="Formalización · Condiciones de la línea"
    title="Revisa las condiciones antes de firmar"
    subtitle="Antes de firmar, confirma las condiciones definitivas calculadas con tu expediente autorizado."
  />
);
